import React, { useState } from 'react'
import { Card, CardBody, CardFooter, CardHeader, Image } from '@nextui-org/react'
import {useParams} from 'react-router-dom'
import { useQuery } from '@tanstack/react-query';
import { getArticleById } from '../../services/querys '
import moment from 'moment';

function Article() {

    const {id} = useParams()

    const { isLoading, data, error } = useQuery({
        queryKey: [`article/${id}`],
        queryFn: () => getArticleById(id),
        enabled: !!id,
        refetchOnWindowFocus: false
    });


    return (
        <>
            <div className='flex item-center justify-center'>

                <Card className='flex mt-8 sm:mt-[75px] font-poppins max-w-5xl bg-transparent'>
                    <CardHeader className='block'>
                        <h2 className='text-3xl md:text-5xl font-bold text-gray-200 font-poppins lg:leading-normal'>{data?.articleName}</h2>
                        <p className='text-sm md:text-lg mb-1 mt-3 font-normal text-gray-400 font-poppins  capitalize'>{moment(data?.updatedAt).fromNow()} | by editor</p>
                    </CardHeader>
                    <CardBody className='block'>
                        <Image
                            loading='lazy'
                            alt="Article name"
                            src={data?.image[0]?.url}
                            className='w-full cursor-pointer'
                        >
                        </Image>

                        <div
                            className="article-content mb-1 mt-3 font-poppins text-gray-100 leading-relaxed"
                            dangerouslySetInnerHTML={{ __html: data?.description }}
                        />

                    </CardBody>
                    <CardFooter></CardFooter>
                </Card>


            </div>
        </>

    )
}

export default Article